import { Box, Button, Alert, Typography, Paper, Fade } from "@mui/material";
import { useState } from "react";

const TestActivateStep = () => {
  const [success, setSuccess] = useState(false);

  const handleTest = () => {
    setSuccess(true);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: 3,
      }}
    >
      <Typography variant="h6" fontWeight={600}>
        Test Your Integration
      </Typography>

      <Typography color="text.secondary" fontSize="0.9rem" maxWidth={360}>
        Send a sample POST request to verify the endpoint is configured
        correctly.
      </Typography>

      <Button
        variant="contained"
        color="primary"
        onClick={handleTest}
        sx={{
          px: 4,
          py: 1.2,
          borderRadius: 2,
          textTransform: "none",
          fontSize: "0.95rem",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        Send Test Request
      </Button>

      <Fade in={success} timeout={500}>
        <Paper
          elevation={0}
          sx={{
            mt: 1,
            p: 3,
            borderRadius: 3,
            border: "1px solid #d4e8da",
            backgroundColor: "#f3fcf5",
            minWidth: 360,
            maxWidth: "100%",
          }}
        >
          <Alert
            severity="success"
            sx={{
              mb: 1,
              "& .MuiAlert-message": { fontWeight: 600 },
            }}
          >
            Test lead received successfully!
          </Alert>

          <Typography fontSize="0.85rem" color="text.secondary">
            Your integration is active and working properly.
          </Typography>
        </Paper>
      </Fade>

      {!success && (
        <Typography fontSize="0.85rem" color="text.secondary" mt={1}>
          Once the test is successful, your client can start sending real leads.
        </Typography>
      )}
    </Box>
  );
};

export default TestActivateStep;
